import ServiceExec from '@/common/utils/ServiceExec';
import { payment } from '@/common/service/apiList';
import store from '@/store';
import { isEmpty } from '@/common/utils/Util';

export default {
  getPaymentList: async function({ commit, getters, state }) {
    const condition = getters['getCondition'];
    if (condition.page > state.pageInfo.endPage) return;
    const { userNo } = store.getters['user/getUserData'];

    condition.userNo = userNo;
    const { data, status } = await ServiceExec.get(payment.getList, condition);
    if (ServiceExec.status.OK !== status) return false;
    const { list, pageInfo } = data;
    if (isEmpty(list)) return;
    condition.page = condition.page + 1;
    commit('setCondition', condition);
    commit('setPageInfo', pageInfo);
    commit('setPaymentList', list ?? []);
  },

  fetchCanSuperChat: async function({ commit }) {
    let userData = store.getters['user/getUserData'];
    if (!userData.userNo) return;
    const { data, status } = await ServiceExec.get(payment.fetchSuperChat(userData.userNo));
    if (ServiceExec.status.OK !== status) return false;
    store.commit('user/setUserData', { ...userData, canSuperChat: data });
  }
};
